import { AddStrikerIcon, EmailIcon, NameIcon } from "icons";
import styles from "./styles.module.scss";
import { CrossIcon } from "icons/crossIcon";
import { useState } from "react";
import { ConditionalRenderer } from "components";
import { FormLabel } from "pages/analyticsV2/components/form-label";
import { Input } from "antd";

export const AddStriker = () => {
  const [openAddStriker, setOpenAddStriker] = useState(false);
  return (
    <div className={styles.addStrikerContainer}>
      <button
        className={styles.addStrikerBtn}
        onClick={() => setOpenAddStriker((prev) => !prev)}
        type="submit"
      >
        <span>Search</span>
      </button>
    </div>
  );
};
